import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.trouble-ticket-senden';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTroubleTicketSendenEffects {

    TroubleTicketSenden$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_TROUBLE_TICKET_SENDEN),
        mergeMap((x: ac.PostTroubleTicketSendenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postTroubleTicketSenden(x.troubleTicketSendenRequest).pipe(
                map((result: any) => {
                    return new ac.PostTroubleTicketSendenErfolgreichAction(result, x.troubleTicketSendenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostTroubleTicketSendenFehlerAction(error, x.troubleTicketSendenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketCommandService);
        }
        return this.service;
    }
}
